export const PORTAL_ROOT_SELECTOR = "#portal-root";